/**
 * RESPONSIBILITY: draw a block that is a grid of photographs, each opening full size.
 *
 * A grid and not a carousel: every photograph at once, findable and printable.
 */
import { idOf, hasImage } from '@framework/core';
import { ADC_THEME } from '@app/sections';
import { AdcBand } from './AdcBand';
import { Enlarge } from '../commons/Enlarge';
import type { AdcBlockProps } from './kind';

export function AdcGallery({ b }: AdcBlockProps) {
  const pics = (b.pictures ?? []).filter((p) => hasImage(p.image));
  if (!pics.length) return null;

  return (
    <AdcBand theme={ADC_THEME.Gallery} heading={b.heading}>
      <ul className="adc-gallery">
        {pics.map((p) => (
          <li key={idOf(p)}>
            <Enlarge value={p.image} className="adc-shot" />
            {p.caption ? <span className="ev-caption">{p.caption}</span> : null}
          </li>
        ))}
      </ul>
    </AdcBand>
  );
}
